import { getLanguageCookie } from "../utils/cookies";

export const decorateUrlWithLanguagePath = (url: string) => {
  const language = getLanguageCookie()
  if (language === 'ar') {
    return `/ar${url}`
  }
  return url;
}
